<template>
    <div class="venue-coach-details">
        <layouts-header></layouts-header>

        <!--Galler Slider Section-->
        <div class="bannergallery-section">
            <div class="main-gallery-slider owl-carousel owl-theme">
                <venue-carousel></venue-carousel>
            </div>
            <div class="showphotos corner-radius-10">
                <a href="javascript:void(0);" data-fancybox="gallery1"><i
                        class="fa-regular fa-images"></i>More Photos</a>
            </div>
        </div>
        <div class="venue-info white-bg d-block">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                        <h1 class="d-flex align-items-center justify-content-start">Badminton Academy<span
                                class="d-flex justify-content-center align-items-center"><i
                                    class="fas fa-check-double"></i></span></h1>
                        <ul class="d-sm-flex justify-content-start align-items-center">
                            <li><i class="feather-map-pin"></i>70 Bright St New York, USA</li>
                            <li><i class="feather-phone-call"></i>+3 80992 31212</li>
                            <li><i class="feather-mail"></i><a href="mailto:yourmail@example.com"> yourmail@example.com</a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12 col-lg-6 text-right">
                        <ul class="social-options float-lg-end d-sm-flex justify-content-start align-items-center">
                            <li><a href="javascript:void(0);"><i class="feather-share-2"></i>Share</a></li>
                            <li><a href="javascript:void(0);" class="favour-adds"><i class="feather-star"></i>Add to
                                    favourite</a></li>
                            <li class="venue-review-info d-flex justify-content-start align-items-center">
                                <span class="d-flex justify-content-center align-items-center">5.0</span>
                                <div class="review">
                                    <div class="rating">
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                        <i class="fas fa-star filled"></i>
                                    </div>
                                    <p class="mb-0"><a href="javascript:;">15 Reviews</a></p>
                                </div>
                                <i class="fa-regular fa-comments"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <hr>
                <div class="row bottom-row d-flex align-items-center">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <ul class="d-sm-flex details">
                            <li>
                                <div class="profile-pic">
                                    <a href="javascript:void(0);" class="venue-type"><img class="img-fluid"
                                            src="@/assets/img/icons/venue-type.svg" alt="Icon"></a>
                                </div>
                                <div class="ms-2">
                                    <p>Venue Type</p>
                                    <h6 class="mb-0">Indoor</h6>
                                </div>
                            </li>
                            <li>
                                <div class="profile-pic">
                                    <a href="javascript:void(0);"><img class="img-fluid"
                                            src="@/assets/img/profiles/avatar-01.jpg" alt="Icon"></a>
                                </div>
                                <div class="ms-2">
                                    <p>Added By</p>
                                    <h6 class="mb-0">Hendry Williams</h6>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="d-flex float-sm-end align-items-center">
                            <p class="d-inline-block me-2 mb-0">Starts From :</p>
                            <h3 class="primary-text mb-0 d-inline-block">$150<span>/ hr</span></h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Page Content -->
        <div class="content">
            <div class="container">
                <!-- Row -->
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                        <div class="venue-options white-bg mb-4">
                            <ul class="clearfix">
                                <li class="active"><a href="#overview">Overview</a></li>
                                <li><a href="#includes">Includes</a></li>
                                <li><a href="#rules">Rules</a></li>
                                <li><a href="#amenities">Amenities</a></li>
                                <li><a href="#gallery">Gallery</a></li>
                                <li><a href="#reviews">Reviews</a></li>
                                <li><a href="#location">Locations</a></li>
                            </ul>
                        </div>

                        <!-- Accordian Contents -->
                        <div class="accordion" id="accordionPanel">
                            <div class="accordion-item mb-4" id="overview">
                                <h4 class="accordion-header" id="panelsStayOpen-overview">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                                        aria-controls="panelsStayOpen-collapseOne">
                                        Overview
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-overview">
                                    <div class="accordion-body">
                                        <div class="text show-more-height" ref="textElement">
                                            <p>Badminton Academy is a renowned sports facility situated in Sacramento, CA.
                                                With
                                                a commitment to providing high-quality services, we offer a range of
                                                amenities
                                                and equipment to support athletes in their training and development.</p>


                                            <p>Our facility is equipped with state-of-the-art features, ensuring a conducive
                                                environment for athletes to excel in their respective sports.</p>


                                            <p>Whether you're a professional athlete or a sports enthusiast, Sarah Sports
                                                Academy is the ideal place to enhance your skills and achieve your goals.
                                                Contact Mart Dublin for more information and to book your next training
                                                session.
                                            </p>
                                        </div>
                                        <div class="show-more align-items-center primary-text" @click="toggleTextVisibility"><i
                                                class="feather-plus-circle"></i>Show More</div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item mb-4" id="includes">
                                <h4 class="accordion-header" id="panelsStayOpen-includes">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseTwo">
                                        Includes
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-includes">
                                    <div class="accordion-body">
                                        <ul class="clearfix">
                                            <li><i class="feather-check-square"></i>Badminton Racket Unlimited</li>
                                            <li><i class="feather-check-square"></i>Bats</li>
                                            <li><i class="feather-check-square"></i>Hitting Machines</li>
                                            <li><i class="feather-check-square"></i>Multiple Courts</li>
                                            <li><i class="feather-check-square"></i>Spare Players</li>
                                            <li><i class="feather-check-square"></i>Instant Racket</li>
                                            <li><i class="feather-check-square"></i>Green Turfs</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item mb-4" id="rules">
                                <h4 class="accordion-header" id="panelsStayOpen-rules">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseThree">
                                        Rules
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-rules">
                                    <div class="accordion-body">
                                        <ul>
                                            <li>
                                                <p><i class="feather-alert-octagon"></i>Non Marking Shoes are recommended
                                                    not
                                                    mandatory for Badminton.</p>
                                            </li>
                                            <li>
                                                <p><i class="feather-alert-octagon"></i>A maximum number of members per
                                                    booking
                                                    per badminton court is admissible fixed by Venue Vendors</p>
                                            </li>
                                            <li>
                                                <p><i class="feather-alert-octagon"></i>No pets, no seeds, no gum, no glass,
                                                    no
                                                    hitting or swinging outside of the cage</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item mb-4" id="amenities">
                                <h4 class="accordion-header" id="panelsStayOpen-amenities">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseFour">
                                        Amenities
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-amenities">
                                    <div class="accordion-body">
                                        <ul class="d-md-flex justify-content-between align-items-center">
                                            <li><i class="fa fa-check-circle" aria-hidden="true"></i>Parking</li>
                                            <li><i class="fa fa-check-circle" aria-hidden="true"></i>Drinking Water</li>
                                            <li><i class="fa fa-check-circle" aria-hidden="true"></i>First Aid</li>
                                            <li><i class="fa fa-check-circle" aria-hidden="true"></i>Change Room</li>
                                            <li><i class="fa fa-check-circle" aria-hidden="true"></i>Shower</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item mb-4" id="gallery">
                                <h4 class="accordion-header" id="panelsStayOpen-gallery">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseFive" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseFive">
                                        Gallery
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-gallery">
                                    <div class="accordion-body">
                                        <gallery-carousel></gallery-carousel>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item mb-4" id="reviews">
                                <div class="accordion-header" id="panelsStayOpen-reviews">
                                    <div class="accordion-button d-flex justify-content-between align-items-center"
                                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix"
                                        aria-controls="panelsStayOpen-collapseSix">
                                        <span class="w-75 mb-0">
                                            Reviews
                                        </span>
                                        <a href="javascript:void(0);"
                                            class="btn btn-gradient pull-right write-review add-review"
                                            data-bs-toggle="modal" data-bs-target="#add-review">Write a review</a>
                                    </div>
                                </div>
                                <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-reviews">
                                    <div class="accordion-body">
                                        <div class="row review-wrapper">
                                            <div class="col-lg-3">
                                                <div class="ratings-info corner-radius-10 text-center">
                                                    <h3>4.8</h3>
                                                    <span>out of 5.0</span>
                                                    <div class="rating">
                                                        <i class="fas fa-star filled"></i>
                                                        <i class="fas fa-star filled"></i>
                                                        <i class="fas fa-star filled"></i>
                                                        <i class="fas fa-star filled"></i>
                                                        <i class="fas fa-star filled"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="recommended">
                                                    <h5>Recommended by 97% of Players</h5>
                                                    <div class="row">
                                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                                                            <p class="mb-0">Quality of service</p>
                                                            <ul>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><span>5.0</span></li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                                                            <p class="mb-0">Quality of service</p>
                                                            <ul>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><span>5.0</span></li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4 mb-3">
                                                            <p class="mb-0">Quality of service</p>
                                                            <ul>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><span>5.0</span></li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                            <p class="mb-0">Quality of service</p>
                                                            <ul>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><span>5.0</span></li>
                                                            </ul>
                                                        </div>
                                                        <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                                                            <p class="mb-0">Quality of service</p>
                                                            <ul>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><i></i></li>
                                                                <li><span>5.0</span></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Review Box -->
                                        <div class="review-box d-md-flex">
                                            <div class="review-profile">
                                                <img src="@/assets/img/profiles/avatar-01.jpg" alt="User">
                                            </div>
                                            <div class="review-info">
                                                <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                                                <div class="rating">
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <span class="">5.0</span>
                                                </div>
                                                <span class="success-text"><i class="feather-check"></i>Yes, I would book
                                                    again.</span>
                                                <h6>Absolutely perfect</h6>
                                                <p>If you are looking for a perfect place for friendly matches with your
                                                    friends
                                                    or a competitive match, It is the best place.</p>
                                                <venue-gallery></venue-gallery>
                                                <span class="post-date">Sent on 11/03/2023</span>
                                            </div>
                                        </div>
                                        <!-- /Review Box -->

                                        <!-- Review Box -->
                                        <div class="review-box d-md-flex">
                                            <div class="review-profile">
                                                <img src="@/assets/img/profiles/avatar-06.jpg" alt="User">
                                            </div>
                                            <div class="review-info">
                                                <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                                                <div class="rating">
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <span class="">5.0</span>
                                                </div>
                                                <span class="warning-text"><i class="feather-x"></i>No, I dont want to book
                                                    again.</span>
                                                <h6>Awesome. Its very convenient to play.</h6>
                                                <p>If you are looking for a perfect place for friendly matches with your
                                                    friends
                                                    or a competitive match, It is the best place.</p>
                                                <div class="dull-bg">
                                                    <p>Experience badminton excellence at Badminton Academy. Top-notch
                                                        facilities, well-maintained courts, and a friendly atmosphere.
                                                        Highly
                                                        recommended for an exceptional playing experience</p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /Review Box -->
                                        <div class="d-flex justify-content-center mt-1">
                                            <button type="button"
                                                class="btn btn-load-more d-flex justify-content-center align-items-center">Load
                                                More<i class="feather-plus-square"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item" id="location">
                                <h4 class="accordion-header" id="panelsStayOpen-location">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#panelsStayOpen-collapseSeven" aria-expanded="false"
                                        aria-controls="panelsStayOpen-collapseSeven">
                                        Location
                                    </button>
                                </h4>
                                <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse show"
                                    aria-labelledby="panelsStayOpen-location">
                                    <div class="accordion-body">
                                        <div class="google-maps">
                                            <iframe
                                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8862835683544!2d-73.98256668525309!3d41.93829486962529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd0ee3286615b7%3A0x42bfa96cc2ce4381!2s132%20Kingston%20St%2C%20Kingston%2C%20NY%2012401%2C%20USA!5e0!3m2!1sen!2sin!4v1670922579281!5m2!1sen!2sin"
                                                height="445" style="border:0;" allowfullscreen="" loading="lazy"
                                                referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                        <div class="dull-bg d-flex justify-content-start align-items-center mt-3">
                                            <div class="white-bg me-2">
                                                <i class="fas fa-location-arrow"></i>
                                            </div>
                                            <div class="">
                                                <h6>Our Venue Location</h6>
                                                <p>70 Bright St New York, USA</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Accordian Contents -->
                    </div>
                    <venue-sidebar></venue-sidebar>
                </div>
                <!-- /Row -->
            </div>
            <!-- /Container -->

            <section class="section innerpagebg">
                <div class="container">
                    <div class="featured-slider-group">
                        <h3 class="mb-40">Similar Venues</h3>
                        <div class="owl-carousel featured-venues-slider owl-theme">

                            <venue-details-carousel></venue-details-carousel>

                        </div>
                    </div>
                </div>
            </section>

        </div>
        <!-- /Page Content -->

        <layout-footer></layout-footer>

        <coach-detail-modal></coach-detail-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            buttonText: 'Show More',
        }
    },
    methods: {
    toggleTextVisibility() {
      const textElement = this.$refs.textElement;

      if (textElement.classList.contains('show-more-height')) {
        this.buttonText = '<i class="feather-minus-circle"></i>Show Less';
      } else {
        this.buttonText = '<i class="feather-plus-circle"></i>Show More';
      }

      textElement.classList.toggle('show-more-height');
    },
  },
}
</script>